import { render, staticRenderFns } from "./TncPage.vue?vue&type=template&id=e51962d0&"
import script from "./TncPage.vue?vue&type=script&lang=js&"
export * from "./TncPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports